

/**
 * Interactions for removing existing avatar asynchronously
 */
export class ProfileAvatar {
  /**
   * @param {object} $element jQuery DOM element to apply avatar functionality to
   */
  constructor($element) {
    this.button = $('a', $element);
    this.avatar = $('.avatar-image', $element);
    this.image = $('img', $element);

    this.button.on('click', this.remove.bind(this));
  }

  /**
   * Removes Avatar asynchronously
   * @param {object} event Listener event
   */
  remove(event) {
    this.setStartState();

    $.ajax({
      url: '/api/removeAvatar',
      dataType: 'json'
    }).then(this.setSuccessState.bind(this), this.setFailedState.bind(this));

    event.preventDefault();
  }

  /**
   * Sets visual start state
   */
  setStartState() {
    this.button.addClass('disabled');
    this.avatar.addClass('in-transit');
  }

  /**
   * Sets visual success state
   */
  setSuccessState() {
    setTimeout(() => {
      this.image.removeClass('is-avatar').attr('src', this.image.data('default'));
      this.button.remove();
      this.avatar.removeClass('in-transit');
    }, 1000);
  }

  /**
   * Sets visual failed state
   */
  setFailedState() {
    setTimeout(() => {
      this.button.removeClass('disabled');
      this.avatar.removeClass('in-transit');
    }, 1000);
  }
}
